import { useEffect, useState } from 'react'
import { IEvent } from '../../../models/events'
import { IRootState } from '@/redux/types'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

function useEventModalState() {
  const { t } = useTranslation(['global'])

  const { event_selected } = useSelector((state: IRootState) => state.event)

  const STATUS = [
    { id: 1, name: t('active') },
    { id: 0, name: t('inactive') }
  ]

  const VISIBILITY = [
    { id: 0, name: t('private') },
    { id: 1, name: 'VIP' },
    { id: 2, name: t('public') },
    { id: 3, name: t('preregistration') }
  ]

  const [eventState, setEventState] = useState<IEvent>({
    id: null,
    brand: null,
    line: null,
    country: null,
    languages: [],
    title: '',
    description: '',
    speaker: '',
    link: '',
    file: null,
    filePreview: null,
    text_button: null,
    background_color: { hex: '#5e72e4' },
    text_color: { hex: '#5e72e4' },
    method: 0,
    type: 0,
    status: null,
    visibility: null,
    role: [],
    startDate: null,
    endDate: null
  })

  useEffect(() => {
    if (event_selected != null) {
      setEventState({
        id: event_selected.id,
        brand: event_selected.brand,
        line: event_selected.line,
        country: event_selected.country,
        languages: event_selected.languages.map((language: any) => language.id),
        title: event_selected.title,
        description: event_selected.description,
        speaker: event_selected.speaker,
        link: event_selected.link,
        file: null,
        filePreview: event_selected.image,
        text_button: event_selected.text_button,
        background_color: { hex: event_selected.background_color },
        text_color: { hex: event_selected.text_color },
        method: event_selected.method,
        type: event_selected.type,
        status: STATUS.find(status => status.id === event_selected.status),
        visibility: VISIBILITY.find(visibility => visibility.id === event_selected.visibility),
        role: event_selected.role,
        startDate: event_selected.date_ini !== null ? dayjs(event_selected.date_ini) : null,
        endDate: event_selected.date_end !== null ? dayjs(event_selected.date_end) : null
      })
    }
  }, [event_selected])

  const handleInputChange = (inputName: string, value: any) => {
    setEventState({ ...eventState, [inputName]: value })
  }

  const handleInputChangeFile = (event: any) => {
    const value = event.target.files[0]
    setEventState({ ...eventState, file: value })
  }

  return { eventState, handleInputChange, handleInputChangeFile, VISIBILITY, STATUS }
}

export default useEventModalState
